<template>
    <MessageScreen
        :srcImageMessage="IconWarning"
        :isVisibleSecondaryMessage="true"
        :titleMessage="'Esse CPF já foi cadastrado!'"
        :message="'Parece que uma conta com esse CPF ja foi cadastrada.'"
        :secondaryMessage="'Faça login ou tente cadastrar outro CPF.'"
    />
    <FooterButton
        :primaryButton="false"
        :secondaryButton="true"
        :textPrimaryButton="'Fazer login'"
        :confirmDataSecondary="backInitialData"
        :confirmData="backLogin"
    />
</template>
<script>
  import MessageScreen from '../../components/MessageScreen.vue'
  import FooterButton from '../../components/FooterButton.vue'
  import { useRouter } from 'vue-router'
  import IconWarning from '../../../../public/images/Bonequinho-alerta.svg'
  

  export default {
      components: {
          MessageScreen,
          FooterButton,
      },
      setup() {
        const router = useRouter();
         
        const backLogin = async () => {
            window.location.href = '/entrar';
        }

        const backInitialData = async () => {
            router.push({ name: 'InitialPersonalDataForm' })
        }
  
        return {          
            IconWarning,
            backLogin,
            backInitialData
        };
      }, 
  }
</script>
